const config = {
  contentful: {
    space: 'lmhkhfj6ao4p',
    accessToken: 'E49gI3J9dd_LwdKdEid9jkFugyb3HYV6QiqBIeoyq0k'
  }
};

export default config;
